// extracted by mini-css-extract-plugin
export default {"BalanceContainer":"style_BalanceContainer__HKSp0","title":"style_title__h1Q+q","value":"style_value__yQGZd","description":"style_description__ME1gA"};